var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "day-badge",
    "class": {
      'day-badge--novy': _vm.isNovy
    },
    style: {
      opacity: _vm.badgeOpacity
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }